export const ValidationDefaultValues = {
    // ogolne
    requiredComments: false,
    // wprowadzenie
    boarOnlyOnBoarChamber: true,
    maxPigletInsertionTimeDifference: 35,
    maxPorkerInsertionTimeDifference: 35,
    // inseminacja
    inseminationOnMating: true,
    blockDifferentSpermInCycle: true,
    maxCycleInseminations: 0,
    checkPigletsCountOnInsemination: true,
    // usg
    usgWithoutInsemination: true,
    daysFromInseminationToUSG: true,
    checkDaysFromInseminationToUSG: false,
    // porod
    parturitionOnDelivery: true,
    parturitionWithoutInsemination: true,
    parturitionAfterParturition: true,
    daysFromInseminationToParturition: true,
    maxHealthyCnt: 50,
    maxWeakCnt: 50,
    maxMummyCnt: 50,
    maxDeadCnt: 50,
    maxPigletsWithSow: 50,
    averagePigletWeightForParturition: [1000, 4000],
    // odsad
    separationOnDelivery: true,
    separationWithoutParturition: true,
    separationWithMorePigletsThanAnimalHas: true,
    averagePigletWeightForSeparation: [5000, 10000],
    partialSeparationReport: true,
    maxPigletSeparationTimeDifference: 35,
    // przeniesienie
    transferAnimalWithPiglets: true,
    maxPigletTransferTimeDifference: 35,
    maxPorkerTransferTimeDifference: 35,
    requireWeightOnPigletToPorkerTransfer: true,
    // brak ciazy
    noPregnancyWithoutInsemination: true,
    // upadek
    requireToSubmitEstimatedWeight: true,
    blockFallWithTransfers: true,
    checkPigletsCountOnFallOfSow: true,
    // tatuowanie
    tattooGiltsWithOneBoar: false,
    // sprzedaz
    averagePigletWeightForSale: [20000, 40000],
    averagePorkerWeightForSale: [100000, 120000],
    blockSaleWithTransfers: true,
    withdrawalPeriodWarn: false,
    checkPigletsCountOnSellOfSow: true,
    // usuwanie
    removeAnimalWithEvents: true,
    // taski
    markTaskAsCompleted: false,
    markTaskAsCompletedAfterDate: false,
    // brak na widoku
    parturitionWithPositiveBalance: true,
    maxIntervalBetweenSeparations: 14,
    //Odstępy miedzy eventami
    sowAlive: 260,
    inseminationAfterSeparation: 3,
    noPregnancyAfterInsemination: 18,
    separationAfterParturition: 5,
};
